import {v4 as uuid} from 'uuid';

import {swapIds} from './json-logic-utils';

export function cloneForm(newName, form) {
  const idMap = [
    ...form.contextQuestions,
    ...form.questions,
    ...(form.elements || [])
  ].map(question => question.id)
  .reduce((map, oldId) => {
    const newId = uuid();
    map[oldId] = newId;
    return map;
  }, {});

  return {
    ...form,
    name: newName,
    tags: form.tags || [],
    contextQuestions: form.contextQuestions.map(question => ({
      ...question,
      id: idMap[question.id],
      condition: (question.condition ? JSON.stringify(swapIds(JSON.parse(question.condition), idMap)) : null)
    })),
    questions: form.questions.map(question => ({
      ...question,
      id: idMap[question.id],
      condition: (question.condition ? JSON.stringify(swapIds(JSON.parse(question.condition), idMap)) : null)
    })),
    elements: form.elements ? form.elements.map(element => ({
      ...element,
      id:idMap[element.id],
      data: {
        label: element.data.label,
        defaultValue: element.data.defaultValue,
        formula: (element.data.formula ? JSON.stringify(swapIds(JSON.parse(element.data.formula), idMap)) : null)
      },
      condition: (element.condition ? JSON.stringify(swapIds(JSON.parse(element.condition), idMap)) : null)
    })) : [],
    alerts: form.alerts.map((alert) => ({
      ...alert,
      id: uuid(),
      expression: JSON.stringify(swapIds(JSON.parse(alert.expression), idMap))
    })),
    contextAlerts: form.contextAlerts ? form.contextAlerts.map((contextAlert) => ({
      ...contextAlert,
      id: uuid(),
      expression: JSON.stringify(swapIds(JSON.parse(contextAlert.expression), idMap))
    })) : []
  };
}

export function canImportToForm(form) {
  if (!form.published || !form.current || getImportableQuestions(form).length <= 0) {
    return false;
  }

  return true;
}

const rejectedImportTypes = [
  "SIGNATURE",
  "IMAGE"
]

export function getImportableQuestions(form) {
  return [...form.contextQuestions, ...form.questions].filter(question => rejectedImportTypes.indexOf(question.type) < 0);
}